import percent from '@pkg/utils/numbers/percent';

/**
 * Calculates the percentage change between two values.
 * @param {Number} primary
 * @param {Number} secondary
 *
 * @return {Number}
 */
export default function percentageChange(
  originalValue,
  changeValue,
  precision
) {
  if (isNaN(originalValue) || isNaN(changeValue)) {
    return;
  }

  if (originalValue === 0 && changeValue === 0) {
    return 0;
  }

  if (originalValue === 0) {
    return changeValue > 0 ? 1 : -1;
  }

  return percent(changeValue - originalValue, originalValue, precision);
}
